// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"KQ-z","inlineTitle":"LQ-z","sponsoredAdsWrapper":"MQ-z","marketplaceRecosWrapper":"NQ-z"};